export default __webpack_public_path__ + "static/media/black-1.4c7ba8d0.mp4";